import { useEffect, useState } from "react";
import api, { formatApiError, formatMoney } from "@/lib/api";

const FILAS = [
  ["pedidos", "Pedidos del mes (nuevos)", false],
  ["ventas", "Ventas del mes", true],
  ["facturado", "Facturado", true],
  ["gastos", "Gastos (Libro de Cuentas)", true],
];

export const CuadreDashboard = ({ rango }) => {
  const { hasta } = rango;
  const key = JSON.stringify(rango);
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.post("/cierres-mes/cuadre-dashboard", JSON.parse(key)).then(({ data }) => setD(data)).catch((e) => setErr(formatApiError(e)));
  }, [key]);
  if (err) return <div className="text-xs text-red-700">{err}</div>;
  if (!d) return <div className="text-xs text-zinc-500">Calculando cuadre con el Dashboard…</div>;
  const f = (v, money) => (money ? formatMoney(v) : v);
  return (
    <div className="border rounded overflow-x-auto" data-testid="cuadre-dashboard">
      <table className="w-full text-xs">
        <thead className="bg-zinc-100 text-left">
          <tr><th className="px-2 py-1">Concepto</th><th className="px-2 py-1 text-right">Dashboard hoy</th><th className="px-2 py-1 text-right">Entra al cierre (hasta {hasta})</th><th className="px-2 py-1 text-right">Queda para el mes siguiente</th></tr>
        </thead>
        <tbody className="divide-y">
          {FILAS.map(([k, label, money]) => (
            <tr key={k} data-testid={`cuadre-${k}`}>
              <td className="px-2 py-1 font-semibold">{label}</td>
              <td className="px-2 py-1 text-right tabular-nums">{f(d[k].dash, money)}</td>
              <td className="px-2 py-1 text-right tabular-nums font-bold">{f(d[k].cierre, money)}</td>
              <td className="px-2 py-1 text-right tabular-nums">{f(d[k].sig, money)}</td>
            </tr>
          ))}
          <tr data-testid="cuadre-por-facturar">
            <td className="px-2 py-1 font-semibold">Por facturar</td>
            <td className="px-2 py-1 text-right tabular-nums">{formatMoney(d.por_facturar)}</td>
            <td className="px-2 py-1 text-right" colSpan={2}>Se traslada completo al mes siguiente</td>
          </tr>
        </tbody>
      </table>
      <div className="px-2 py-1 text-[11px] text-zinc-500 bg-zinc-50">Dashboard hoy = Entra al cierre + Queda para el mes siguiente (todo lo registrado después de {hasta}).</div>
      <div className="px-2 py-2 border-t" data-testid="cuadre-diferencias">
        <div className="text-[10px] uppercase tracking-widest font-black text-red-700 mb-1">Por qué el pre-cierre no es igual al Dashboard</div>
        <ul className="space-y-1 text-[11px]">
          {d.diferencias.map((x, i) => (
            <li key={i} data-testid={`cuadre-dif-${i}`}>
              <b>{x.cantidad !== null ? `${x.cantidad} · ` : ""}{formatMoney(x.monto)}</b> — {x.concepto}
              {x.pedidos && <div className="text-zinc-500 break-words">{x.pedidos}</div>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
